class LoginController {
  constructor(User, $state) {
    "ngInject";
    this.name = 'login';
    this.User = User;

    this.$state = $state;
    this.alerts = [];
  }

  login(email, password) {
    this.loading = true;
    this.User.login(email, password).then((data) => {
        console.log('login sucessfull');
        this.$state.go('home');
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
        this.loading = false;
        this.showError(err.message);
      });
  }

  showError(err) {
    this.alert = {};
    this.alert = err;
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/auth/login/login.controller.js